export default {
  REMOVE_MESSAGE: "removeMessage",
};
